module.exports = __webpack_public_path__ + "static/media/sections_thumb.2fbc5e21.jpg";